import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "verification-page" }
const _hoisted_2 = { class: "verification-content" }
const _hoisted_3 = { class: "input-section" }
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = { class: "section-title" }
const _hoisted_6 = { class: "scan-section" }
const _hoisted_7 = { class: "section-header" }
const _hoisted_8 = { class: "section-title" }
const _hoisted_9 = { class: "scan-tips" }
const _hoisted_10 = {
  key: 0,
  class: "scanner-section"
}
const _hoisted_11 = { class: "scanner-overlay" }
const _hoisted_12 = { class: "scan-guide" }
const _hoisted_13 = { class: "scanner-actions" }
const _hoisted_14 = {
  key: 1,
  class: "result-section"
}
const _hoisted_15 = { class: "status-icon" }
const _hoisted_16 = { class: "status-content" }
const _hoisted_17 = { class: "status-title" }
const _hoisted_18 = { class: "status-message" }
const _hoisted_19 = { class: "scan-info-card" }
const _hoisted_20 = { class: "card-title" }
const _hoisted_21 = { class: "info-grid" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = { class: "scan-count" }
const _hoisted_25 = {
  key: 0,
  class: "info-item"
}
const _hoisted_26 = { class: "scan-time" }
const _hoisted_27 = { class: "info-item" }
const _hoisted_28 = { class: "scan-time" }
const _hoisted_29 = {
  key: 0,
  class: "commodity-card"
}
const _hoisted_30 = { class: "card-title" }
const _hoisted_31 = { class: "commodity-content" }
const _hoisted_32 = {
  key: 0,
  class: "commodity-image"
}
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = { class: "commodity-details" }
const _hoisted_35 = { class: "commodity-name" }
const _hoisted_36 = { class: "commodity-specs" }
const _hoisted_37 = {
  key: 0,
  class: "spec-item"
}
const _hoisted_38 = { class: "spec-content" }
const _hoisted_39 = {
  key: 1,
  class: "spec-item"
}
const _hoisted_40 = { class: "spec-content" }
const _hoisted_41 = {
  key: 2,
  class: "spec-item"
}
const _hoisted_42 = { class: "spec-content" }
const _hoisted_43 = {
  key: 3,
  class: "spec-item"
}
const _hoisted_44 = { class: "spec-content" }
const _hoisted_45 = {
  key: 4,
  class: "spec-item"
}
const _hoisted_46 = { class: "spec-content" }
const _hoisted_47 = {
  key: 5,
  class: "spec-item"
}
const _hoisted_48 = { class: "spec-content" }
const _hoisted_49 = { class: "action-buttons" }
const _hoisted_50 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_51 = {
  key: 3,
  class: "instruction-section"
}
const _hoisted_52 = { class: "instruction-card" }
const _hoisted_53 = { class: "instruction-title" }
const _hoisted_54 = { class: "instruction-steps" }
const _hoisted_55 = { class: "step-item" }
const _hoisted_56 = { class: "step-content" }
const _hoisted_57 = { class: "step-item" }
const _hoisted_58 = { class: "step-content" }
const _hoisted_59 = { class: "step-item" }
const _hoisted_60 = { class: "step-content" }
const _hoisted_61 = { class: "overlay-content" }

import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { showToast } from 'vant'
import { getUserLang } from '@/storage/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'Verify',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()

// 响应式数据
const securityCode = ref('')
const errorMessage = ref('')
const verifying = ref(false)
const scanning = ref(false)
const showScanner = ref(false)
const hasSearched = ref(false)
const showShareSheet = ref(false)
const verificationResult = ref<any>(null)
const scannerContainer = ref<HTMLElement>()
let html5QrCode: any = null

// 模拟验证结果数据
const mockVerificationResult = {
  isFirstScan: true,
  firstScanTime: '2024-01-15T10:30:00Z',
  scanTimes: 1,
  message: '该产品为正品，请放心使用',
  commodityInfo: {
    id: 174,
    sptStyleInfoId: 137688,
    sptStyleColorId: 162973,
    sptClientLinkId: 281,
    sptBrandOfficialAccountsId: 34,
    qty: 15,
    clientLink: 'THE ANTI ORDER',
    collectionNo: '2022-Q3',
    styleNo: 'TAOJK100067',
    sptColor: 'Black/Navy/Red 黑色',
    sizeName: '3XL',
    stylePhoto: 'http://58.215.206.250:8008/static/img/StyleImg/款式图片_20250930171600691.jpg',
    stockType: '夹克',
    styleDescription: 'TOKYO MOTO RACING JACKET',
    country: '澳大利亚',
    imageList: []
  }
}

// 分享选项
const shareOptions = [
  { name: '微信', icon: 'wechat' },
  { name: '朋友圈', icon: 'wechat-moments' },
  { name: '微博', icon: 'weibo' },
  { name: 'QQ', icon: 'qq' },
  { name: '复制链接', icon: 'link' }
]

// 方法
const validateSecurityCode = (code: string): boolean => {
  if (!code.trim()) {
    errorMessage.value = t('verification.codeRequired')
    return false
  }

  if (code.trim().length < 8) {
    errorMessage.value = t('verification.codeTooShort')
    return false
  }

  errorMessage.value = ''
  return true
}

const handleManualVerification = async () => {
  if (!validateSecurityCode(securityCode.value)) {
    return
  }

  await verifySecurityCode(securityCode.value.trim())
}

const verifySecurityCode = async (code: string) => {
  verifying.value = true
  hasSearched.value = true

  try {
    // 模拟API调用
    await new Promise(resolve => setTimeout(resolve, 2000))

    // 模拟根据不同的防伪码返回不同结果
    if (code === '1234567890') {
      verificationResult.value = mockVerificationResult
    } else if (code === '0987654321') {
      verificationResult.value = {
        ...mockVerificationResult,
        isFirstScan: false,
        scanTimes: 5,
        firstScanTime: '2024-01-10T14:20:00Z',
        message: '该产品已验证多次，首次验证时间为2024-01-10'
      }
    } else {
      verificationResult.value = null
      showToast(t('verification.codeInvalid'))
    }
  } catch (error) {
    showToast(t('verification.verifyFailed'))
    verificationResult.value = null
  } finally {
    verifying.value = false
  }
}

const startScan = async () => {
  scanning.value = true

  try {
    // 动态导入html5-qrcode库
    const { Html5Qrcode } = await import('html5-qrcode')

    if (!scannerContainer.value) {
      throw new Error('Scanner container not found')
    }

    // 创建扫码器实例
    html5QrCode = new Html5Qrcode(scannerContainer.value.id)

    // 配置扫码器 - 针对1080×1920设备优化
    const config = {
      fps: 10,
      qrbox: { width: 300, height: 300 }, // 增大扫码框
      aspectRatio: 1.0
    }

    // 开始扫码
    await html5QrCode.start(
      { facingMode: 'environment' },
      config,
      onScanSuccess,
      onScanFailure
    )

    showScanner.value = true
    scanning.value = false
  } catch (error) {
    console.error('Failed to start scanner:', error)
    scanning.value = false

    // 降级方案：使用文件上传方式
    showToast(t('verification.cameraNotAvailable'))
  }
}

const onScanSuccess = (decodedText: string) => {
  // 停止扫码
  stopScan()

  // 将扫码结果填入输入框
  securityCode.value = decodedText

  // 自动开始验证
  handleManualVerification()

  showToast(t('verification.scanSuccess'))
}

const onScanFailure = (error: string) => {
  // 扫码失败的处理，通常是继续扫描
  console.log('Scan failed:', error)
}

const stopScan = () => {
  if (html5QrCode) {
    html5QrCode.stop().then(() => {
      html5QrCode.clear()
      html5QrCode = null
    }).catch((error: any) => {
      console.error('Failed to stop scanner:', error)
    })
  }

  showScanner.value = false
  scanning.value = false
}

const getStatusClass = (result: any) => {
  if (result.isFirstScan) {
    return 'status-first-scan'
  } else if (result.scanTimes <= 3) {
    return 'status-normal'
  } else {
    return 'status-multiple-scans'
  }
}

const getStatusIcon = (result: any) => {
  if (result.isFirstScan) {
    return 'certificate'
  } else {
    return 'shield'
  }
}

const getStatusTitle = (result: any) => {
  if (result.isFirstScan) {
    return t('verification.authenticProduct')
  } else {
    return t('verification.verifiedProduct')
  }
}

const formatDate = (dateString: string | Date) => {
  const date = new Date(dateString)
  const lang = getUserLang()
  return new Intl.DateTimeFormat(lang, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(date)
}

const handleImageLoad = () => {
  // 图片加载成功
}

const handleImageError = () => {
  console.error('商品图片加载失败')
}

const handleVerifyAnother = () => {
  resetSearch()
}

const handleShareResult = () => {
  showShareSheet.value = true
}

const onShareSelect = (option: any) => {
  showShareSheet.value = false

  if (option.name === '复制链接') {
    navigator.clipboard.writeText(window.location.href)
    showToast(t('verification.linkCopied'))
  } else {
    showToast(`${t('verification.sharing')} ${option.name}`)
  }
}

const resetSearch = () => {
  securityCode.value = ''
  errorMessage.value = ''
  verificationResult.value = null
  hasSearched.value = false
}

// 生命周期
onMounted(() => {
  // 可以在这里添加初始化逻辑
})

onUnmounted(() => {
  // 清理扫码器
  if (html5QrCode) {
    stopScan()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_share_sheet = _resolveComponent("van-share-sheet")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$t('verification.title'),
      "left-arrow": "",
      fixed: "",
      placeholder: "",
      "safe-area-inset-top": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_icon, {
            name: "edit",
            class: "section-icon"
          }),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('verification.manualInput')), 1)
        ]),
        _createVNode(_component_van_field, {
          modelValue: securityCode.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((securityCode).value = $event)),
          placeholder: _ctx.$t('verification.enterCode'),
          clearable: "",
          maxlength: "50",
          "error-message": errorMessage.value,
          class: "code-input",
          size: "large"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_van_button, {
              size: "large",
              type: "primary",
              loading: verifying.value,
              disabled: !securityCode.value.trim(),
              class: "verify-btn",
              onClick: handleManualVerification
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('verification.verify')), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "error-message"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_icon, {
              name: "scan",
              class: "section-icon"
            }),
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('verification.scanInput')), 1)
          ]),
          _createVNode(_component_van_button, {
            block: "",
            type: "primary",
            icon: "scan",
            size: "large",
            loading: scanning.value,
            class: "scan-btn",
            onClick: startScan
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('verification.scanCode')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_van_icon, { name: "info" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('verification.scanTip')), 1)
          ])
        ])
      ]),
      (showScanner.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              ref_key: "scannerContainer",
              ref: scannerContainer,
              class: "scanner-container"
            }, null, 512),
            _createElementVNode("div", _hoisted_11, [
              _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"scan-frame\" data-v-13551614><div class=\"frame-corner top-left\" data-v-13551614></div><div class=\"frame-corner top-right\" data-v-13551614></div><div class=\"frame-corner bottom-left\" data-v-13551614></div><div class=\"frame-corner bottom-right\" data-v-13551614></div></div>", 1)),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('verification.scanGuide')), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_van_button, {
                round: "",
                type: "default",
                icon: "cross",
                size: "large",
                class: "close-scanner-btn",
                onClick: stopScan
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (verificationResult.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["status-card", getStatusClass(verificationResult.value)])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_van_icon, {
                  name: getStatusIcon(verificationResult.value)
                }, null, 8, ["name"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h3", _hoisted_17, _toDisplayString(getStatusTitle(verificationResult.value)), 1),
                _createElementVNode("p", _hoisted_18, _toDisplayString(verificationResult.value.message), 1)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.$t('verification.scanInfo')), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.isFirstScan')), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'first-scan': verificationResult.value.isFirstScan })
                  }, _toDisplayString(verificationResult.value.isFirstScan ? _ctx.$t('verification.yes') : _ctx.$t('verification.no')), 3)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.scanTimes')), 1),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(verificationResult.value.scanTimes), 1)
                ]),
                (verificationResult.value.firstScanTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.firstScanTime')), 1),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(formatDate(verificationResult.value.firstScanTime)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.currentScanTime')), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(formatDate(new Date())), 1)
                ])
              ])
            ]),
            (verificationResult.value.commodityInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("h4", _hoisted_30, _toDisplayString(_ctx.$t('verification.commodityInfo')), 1),
                  _createElementVNode("div", _hoisted_31, [
                    (verificationResult.value.commodityInfo.stylePhoto)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("img", {
                            src: verificationResult.value.commodityInfo.stylePhoto,
                            alt: verificationResult.value.commodityInfo.styleDescription,
                            onLoad: handleImageLoad,
                            onError: handleImageError
                          }, null, 40, _hoisted_33)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("h5", _hoisted_35, _toDisplayString(verificationResult.value.commodityInfo.styleDescription || _ctx.$t('verification.unknownProduct')), 1),
                      _createElementVNode("div", _hoisted_36, [
                        (verificationResult.value.commodityInfo.styleNo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createVNode(_component_van_icon, {
                                name: "tag",
                                class: "spec-icon"
                              }),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.styleNo')), 1),
                                _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.styleNo), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (verificationResult.value.commodityInfo.sptColor)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createVNode(_component_van_icon, {
                                name: "color",
                                class: "spec-icon"
                              }),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.color')), 1),
                                _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.sptColor), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (verificationResult.value.commodityInfo.sizeName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createVNode(_component_van_icon, {
                                name: "size",
                                class: "spec-icon"
                              }),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.size')), 1),
                                _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.sizeName), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (verificationResult.value.commodityInfo.stockType)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createVNode(_component_van_icon, {
                                name: "bag",
                                class: "spec-icon"
                              }),
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.category')), 1),
                                _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.stockType), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (verificationResult.value.commodityInfo.country)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createVNode(_component_van_icon, {
                                name: "location",
                                class: "spec-icon"
                              }),
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.country')), 1),
                                _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.country), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (verificationResult.value.commodityInfo.collectionNo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createVNode(_component_van_icon, {
                                name: "certificate",
                                class: "spec-icon"
                              }),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.collection')), 1),
                                _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.collectionNo), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_van_button, {
                type: "primary",
                size: "large",
                class: "action-btn primary-btn",
                onClick: handleVerifyAnother
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_icon, { name: "replay" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('verification.verifyAnother')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_button, {
                type: "default",
                size: "large",
                class: "action-btn secondary-btn",
                onClick: handleShareResult
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_icon, { name: "share" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('verification.shareResult')), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : (hasSearched.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createVNode(_component_van_empty, {
                description: _ctx.$t('verification.noResult'),
                image: "search"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    round: "",
                    type: "primary",
                    size: "large",
                    onClick: resetSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('verification.tryAgain')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["description"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.$t('verification.howToUse')), 1),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "step-number" }, " 1 ", -1)),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('verification.step1Title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('verification.step1Desc')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "step-number" }, " 2 ", -1)),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('verification.step2Title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('verification.step2Desc')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "step-number" }, " 3 ", -1)),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('verification.step3Title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('verification.step3Desc')), 1)
                    ])
                  ])
                ])
              ])
            ]))
    ]),
    _createVNode(_component_van_share_sheet, {
      show: showShareSheet.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showShareSheet).value = $event)),
      options: shareOptions,
      title: _ctx.$t('verification.shareTitle'),
      onSelect: onShareSelect
    }, null, 8, ["show", "title"]),
    _createVNode(_component_van_overlay, {
      show: verifying.value,
      class: "verifying-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_van_loading, {
            size: "32px",
            vertical: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('verification.verifying')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})